<template>
  <div dir="ltr">
    <!-- <div id="carouselSlidesOnly" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div
          class="carousel-item active d-none d-sm-block d-md-block d-lg-block"
        >
          <a href="https://aref-group.ir/sabtenam1402/" target="_blank">
            <img :src="banner" class="d-block w-100" alt="پلان آخر" />
          </a>
        </div>
        <div class="carousel-item active d-block d-sm-none d-md-none d-lg-none">
          
          <a href="https://aref-group.ir/sabtenam1402/" target="_blank">
            <img :src="banner" class="d-block w-100" alt="پلان آخر" />
          </a>
        </div>
      </div>
    </div> -->
  </div>
  <nav
    class="
      navbar navbar-expand-lg navbar-light
      bg-light
      border-bottom
      justify-content-between
    "
  >
    <button
      class="btn"
      @click="toogleMenu()"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div>
      <ul class="list-group list-group-horizontal">
        <li class="list-group-item border-0 p-1 me-md-1">
          <router-link class="btn btn-danger" :to="{ name: 'Cart' }">
            <i class="fas fa-shopping-cart"></i>
            سبد خرید
            <span class="badge bg-primary">
              {{ this.$store.state.cartCount }}
            </span>
          </router-link>
        </li>

        <li class="list-group-item border-0 pt-2 p-1 me-md-1">
          <a
            role="button"
            class="text-decoration-none text-secondary"
            @click="logout"
          >
            خروج
            <i class="fas fa-sign-out-alt"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import ArefApi from "../libs/api.js";

export default {
  name: "TheTopmenu",
  created() {
    if (!this.$socket || !this.$store.state.socket.isConnected) {
      this.$connect();
    }
    this.banner =
      process.env.VUE_APP_API_STORAGE_URL + "/storage/banners/top-banner.jpg";
    this.bannerMobile =
      process.env.VUE_APP_API_STORAGE_URL +
      "/storage/banners/top-banner-mobile.jpg";
  },
  data() {
    return {
      menuToggle: this.$store.state.menuToggle,
      arefApi: new ArefApi(this),
    };
  },
  methods: {
    toogleMenu: function () {
      this.menuToggle = this.menuToggle == "toggled" ? "" : "toggled";
      this.$store.commit("set", ["menuToggle", this.menuToggle]);
    },
    logout: function () {
      this.arefApi.logout();
    },
  },
};
</script>
<style>
.carousel-item {
  float: left !important;
  margin-left: 0 !important;
  margin-right: -100% !important;
}
</style>
